import { render, staticRenderFns } from "./PromotionsSitewideMobile.vue?vue&type=template&id=0ab9a466&scoped=true"
import script from "./PromotionsSitewideMobile.vue?vue&type=script&lang=js"
export * from "./PromotionsSitewideMobile.vue?vue&type=script&lang=js"
import style0 from "./PromotionsSitewideMobile.vue?vue&type=style&index=0&id=0ab9a466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9a466",
  null
  
)

export default component.exports